// Batch 34 · fork b34h — B34-4 per-engagement report settings, B34-5 firm wording for modified reports. EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B34H = {
  en: {
    fmt: {
      mod_qualified_misstatement: "Qualified - misstatement",
      mod_qualified_inability: "Qualified - inability to obtain evidence",
      mod_qualified: "Qualified (older entry, one for both causes)",
      role_text: "Paragraph",
    },
    b34h: {
      wordingEntries: "Saved entries",
      state_saved: "Saved",
      state_empty: "Empty — the AI adaptation / standard wording is used",
      state_needs_splitting: "Needs splitting — used for both causes until you save the misstatement and inability entries",
      state_superseded: "Replaced by the split entries",
      edit: "Edit",
      clear: "Clear",
      cleared: "Entry cleared",
      emptySave: "Enter the wording or leave it empty to use the AI adaptation.",
      placeholdersTitle: "Placeholders you can use",
      placeholdersHelp: "Write them with double braces, e.g. {{entity_short}}. Click one to add it to the text.",
      unknown: "Unknown placeholder(s): {list}. They will print as written. Check the spelling against the list.",
      replaces_opinion: "Replaces only the opinion paragraph; the heading and the introduction stay.",
      replaces_basis: "Replaces only the matter paragraph(s) of the Basis section; the heading and the standard sentences stay.",
      replaces_text: "Replaces only the paragraph of this section; the heading stays.",
      // B34-4
      rsTitle: "Ethics requirements and practice location for this engagement",
      rsIntro: "Leave a field empty to use the firm value (Settings → Firm report settings). Regenerate the report to print a change.",
      rsEthics: "Ethics requirements",
      rsLocation: "Practice location",
      rsFirmValue: "Firm value",
      rsNoFirmValue: "not set",
      rsUsing: "Used in the report",
      rsFromEngagement: "this engagement",
      rsFromFirm: "firm value",
      rsSaved: "Report settings saved — regenerate the report to print them.",
      rsSaveFailed: "Could not save the report settings.",
    },
  },
  ar: {
    fmt: {
      mod_qualified_misstatement: "متحفظ - تحريف",
      mod_qualified_inability: "متحفظ - عدم القدرة على الحصول على أدلة",
      mod_qualified: "متحفظ (إدخال سابق واحد للسببين)",
      role_text: "الفقرة",
    },
    b34h: {
      wordingEntries: "الإدخالات المحفوظة",
      state_saved: "محفوظ",
      state_empty: "فارغ — يُستخدم التكييف بالذكاء الاصطناعي / الصياغة المعيارية",
      state_needs_splitting: "يحتاج إلى فصل — يُستخدم للسببين إلى أن تحفظ إدخالَي التحريف وعدم القدرة",
      state_superseded: "حلّت محله الإدخالات المفصولة",
      edit: "تعديل",
      clear: "مسح",
      cleared: "تم مسح الإدخال",
      emptySave: "أدخل الصياغة، أو اتركها فارغة لاستخدام التكييف بالذكاء الاصطناعي.",
      placeholdersTitle: "العناصر النائبة المتاحة",
      placeholdersHelp: "اكتبها بين قوسين مزدوجين، مثل {{entity_short}}. انقر على أحدها لإضافته إلى النص.",
      unknown: "عناصر نائبة غير معروفة: {list}. ستُطبع كما كُتبت. تحقق من الإملاء مقابل القائمة.",
      replaces_opinion: "تستبدل فقرة الرأي فقط؛ يبقى العنوان والمقدمة.",
      replaces_basis: "تستبدل فقرة (فقرات) الأمر في قسم الأساس فقط؛ يبقى العنوان والجمل المعيارية.",
      replaces_text: "تستبدل فقرة هذا القسم فقط؛ يبقى العنوان.",
      rsTitle: "متطلبات أخلاقيات المهنة وموقع ممارسة المهنة لهذا الارتباط",
      rsIntro: "اترك الحقل فارغاً لاستخدام قيمة المكتب (الإعدادات ← إعدادات تقرير المكتب). أعد إنشاء التقرير لطباعة أي تغيير.",
      rsEthics: "متطلبات أخلاقيات المهنة",
      rsLocation: "موقع ممارسة المهنة",
      rsFirmValue: "قيمة المكتب",
      rsNoFirmValue: "غير مضبوطة",
      rsUsing: "المستخدم في التقرير",
      rsFromEngagement: "هذا الارتباط",
      rsFromFirm: "قيمة المكتب",
      rsSaved: "تم حفظ إعدادات التقرير — أعد إنشاء التقرير لطباعتها.",
      rsSaveFailed: "تعذر حفظ إعدادات التقرير.",
    },
  },
};

export default I18N_B34H;
